var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Error404"},[_vm._v("Error404")])
}
var staticRenderFns = []

export { render, staticRenderFns }